import * as React from "react";

class ButtonHText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="buttonH-text buttonHI-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 433.8 139.9"
      >
        <g>
          <path
            fill="#FCFAEE"
            d="M119.143,49.182h7.833v1.747h-5.744v3.691h4.861v1.765h-4.861v4.285h5.942v1.765h-8.031V49.182z"
          />
          <path
            fill="#FCFAEE"
            d="M129.187,59.805c0-2.125,1.801-3.223,5.924-3.673c-0.018-1.152-0.433-2.161-1.891-2.161
		c-1.044,0-2.017,0.468-2.862,1.008l-0.774-1.404c1.026-0.648,2.412-1.297,3.997-1.297c2.467,0,3.601,1.566,3.601,4.195v5.96h-1.692
		l-0.18-1.134h-0.055c-0.899,0.774-1.962,1.369-3.15,1.369C130.393,62.668,129.187,61.551,129.187,59.805z M135.11,59.877v-2.431
		c-2.935,0.36-3.925,1.098-3.925,2.214c0,0.972,0.666,1.369,1.548,1.369C133.598,61.029,134.3,60.615,135.11,59.877z"
          />
          <path
            fill="#FCFAEE"
            d="M139.068,61.299l0.972-1.333c0.883,0.702,1.747,1.134,2.81,1.134c1.188,0,1.746-0.576,1.746-1.333
		c0-0.9-1.116-1.296-2.196-1.71c-1.314-0.504-2.827-1.207-2.827-2.881c0-1.657,1.332-2.899,3.511-2.899
		c1.333,0,2.413,0.541,3.224,1.171l-0.973,1.278c-0.685-0.504-1.387-0.864-2.215-0.864c-1.08,0-1.584,0.54-1.584,1.224
		c0,0.846,1.026,1.17,2.106,1.566c1.386,0.522,2.917,1.134,2.917,3.007c0,1.657-1.314,3.007-3.764,3.007
		C141.427,62.668,140.022,62.092,139.068,61.299z"
          />
          <path
            fill="#FCFAEE"
            d="M148.05,57.5c0-3.313,2.215-5.222,4.663-5.222c2.449,0,4.664,1.909,4.664,5.222
		c0,3.277-2.215,5.168-4.664,5.168C150.265,62.668,148.05,60.777,148.05,57.5z M155.252,57.5c0-2.106-0.973-3.511-2.539-3.511
		c-1.548,0-2.521,1.404-2.521,3.511c0,2.089,0.973,3.475,2.521,3.475C154.279,60.975,155.252,59.589,155.252,57.5z"
          />
          <path
            fill="#FCFAEE"
            d="M159.804,52.531h1.692l0.162,1.368h0.054c0.919-0.882,1.927-1.621,3.277-1.621
		c2.106,0,3.043,1.405,3.043,3.925v6.23h-2.07v-5.978c0-1.711-0.505-2.395-1.675-2.395c-0.918,0-1.549,0.468-2.431,1.351v7.022
		h-2.053V52.531z"
          />
          <path
            fill="#FCFAEE"
            d="M173.592,55.609c-0.72-0.63-2.16-1.458-3.331-1.944l0.883-1.261c1.152,0.433,2.61,1.188,3.366,1.801
		L173.592,55.609z M175.482,57.914c-0.918,1.873-2.125,4.016-3.187,5.708l-1.423-1.116c0.973-1.369,2.341-3.655,3.385-5.708
		L175.482,57.914z M174.601,50.748c-0.702-0.648-2.143-1.494-3.331-1.98l0.9-1.242c1.188,0.432,2.683,1.224,3.421,1.854
		L174.601,50.748z M180.866,56.978c-0.45,2.628-1.729,5.078-5.023,6.878c-0.307-0.342-0.918-0.936-1.351-1.188
		c2.935-1.549,4.159-3.529,4.627-5.69h-4.015v-1.566h4.268c0.054-0.63,0.071-1.296,0.071-1.945v-1.765h-3.402v-1.566h3.402v-2.791
		h1.675v2.791h4.195v5.276h1.404v1.566H180.866z M181.118,53.467c0,0.648-0.018,1.296-0.072,1.945h2.629v-3.709h-2.557V53.467z
		 M182.973,57.284c1.261,1.8,3.007,4.249,3.854,5.689l-1.495,0.864c-0.773-1.458-2.448-3.979-3.745-5.852L182.973,57.284z"
          />
          <path
            fill="#FCFAEE"
            d="M197.317,61.731c0.793,0.144,1.657,0.18,2.575,0.18c0.792,0,3.799,0,4.825-0.018
		c-0.27,0.396-0.54,1.188-0.612,1.692h-4.303c-3.547,0-6.122-0.594-7.761-3.457c-0.594,1.53-1.44,2.809-2.557,3.781
		c-0.252-0.306-0.954-0.882-1.332-1.135c1.962-1.476,2.881-3.997,3.24-7.166l1.692,0.18c-0.107,0.792-0.233,1.566-0.414,2.269
		c0.648,1.692,1.657,2.646,2.917,3.205v-6.86h-4.159v-1.584h10.138v1.584h-4.25v2.61h5.149v1.567h-5.149V61.731z M190.602,53.413
		h-1.639V49.29h6.788c-0.18-0.522-0.468-1.134-0.72-1.638l1.656-0.486c0.378,0.666,0.792,1.513,1.008,2.125h6.303v4.124h-1.711
		v-2.539h-11.686V53.413z"
          />
          <path
            fill="#FCFAEE"
            d="M218.883,58.887c-0.522,0.9-1.206,1.638-1.999,2.25c2.071,0.504,3.943,1.008,5.348,1.495
		l-1.512,1.17c-1.405-0.522-3.313-1.098-5.528-1.638c-2.034,0.954-4.699,1.44-8.12,1.71c-0.126-0.486-0.396-1.099-0.666-1.458
		c2.448-0.126,4.465-0.396,6.122-0.846c-1.279-0.27-2.575-0.504-3.907-0.738c0.468-0.558,0.99-1.225,1.494-1.944h-3.655v-1.404
		h4.592c0.378-0.595,0.72-1.225,0.972-1.783l1.692,0.36c-0.233,0.468-0.504,0.954-0.792,1.423h4.844
		c0.144-0.324,0.288-0.667,0.414-1.026l1.62,0.45c-0.072,0.18-0.144,0.378-0.216,0.576h2.917v1.404H218.883z M211.519,49.506h-4.789
		v-1.458h15.431v1.458h-4.952v1.314h4.285v4.771h-13.899V50.82h3.925V49.506z M209.16,54.259h2.358v-2.107h-2.358V54.259z
		 M212.005,58.887c-0.252,0.396-0.522,0.756-0.792,1.098c1.206,0.216,2.395,0.432,3.564,0.684c0.847-0.468,1.549-1.063,2.106-1.782
		H212.005z M215.624,49.506h-2.521v1.314h2.521V49.506z M213.104,54.259h2.521v-2.107h-2.521V54.259z M217.208,52.152v2.107h2.629
		v-2.107H217.208z"
          />
          <path
            fill="#FCFAEE"
            d="M230.203,56.618c-0.721,0.216-1.423,0.432-2.125,0.612v4.79c0,0.828-0.162,1.26-0.63,1.513
		c-0.505,0.252-1.207,0.324-2.287,0.306c-0.054-0.414-0.252-1.098-0.45-1.53c0.612,0.036,1.261,0.036,1.44,0.018
		c0.216,0,0.288-0.072,0.288-0.306v-4.303l-1.891,0.522l-0.432-1.62c0.648-0.145,1.458-0.342,2.322-0.576v-3.655h-2.053v-1.549
		h2.053v-3.511h1.639v3.511h1.765v1.549h-1.765v3.205l1.908-0.522L230.203,56.618z M237.891,61.821c1.045,0,1.243-0.486,1.405-2.557
		c0.396,0.27,1.116,0.54,1.62,0.648c-0.271,2.593-0.811,3.511-2.898,3.511h-4.304c-2.269,0-2.971-0.558-2.971-2.863V48.209h9.236
		v9.687h-1.765v-1.152h-5.762v3.817c0,1.062,0.198,1.26,1.404,1.26H237.891z M232.453,49.848v5.312h2.107v-5.312H232.453z
		 M238.215,49.848h-2.088v5.312h2.088V49.848z"
          />
          <path
            fill="#FCFAEE"
            d="M247.158,55.952c-0.288,1.603-0.882,3.241-1.639,4.538c0.307,0.162,0.667,0.45,1.225,0.756
		c1.242,0.72,2.917,0.828,4.987,0.828c2.143,0,5.222-0.162,7.257-0.414c-0.217,0.45-0.505,1.297-0.522,1.765
		c-1.368,0.09-4.682,0.198-6.806,0.198c-2.323,0-3.871-0.18-5.204-0.937c-0.72-0.396-1.368-0.972-1.765-0.972
		c-0.396,0-1.044,1.134-1.548,2.179l-1.116-1.584c0.521-0.685,1.08-1.261,1.584-1.639l-0.018-0.018
		c0.773-0.937,1.386-2.305,1.746-3.619h-2.539c0.505-1.063,1.099-2.539,1.621-3.925h-2.071v-1.513h4.25
		c-0.469,1.279-1.045,2.755-1.566,3.998h0.899l0.234-0.054L247.158,55.952z M244.565,50.838c-0.288-0.774-0.937-2.052-1.368-3.007
		l1.44-0.522c0.468,0.936,1.099,2.143,1.44,2.899L244.565,50.838z M258.483,50.694h-11.325V49.38h5.042
		c-0.252-0.504-0.631-1.188-1.009-1.692l1.603-0.522c0.469,0.594,0.99,1.404,1.242,1.927l-0.828,0.288h5.275V50.694z
		 M248.329,56.384h8.75v4.375h-8.75V56.384z M256.953,52.945h-8.426v-1.243h8.426V52.945z M248.527,54.043h8.426v1.242h-8.426
		V54.043z M249.913,59.517h5.528v-1.891h-5.528V59.517z"
          />
          <path
            fill="#FCFAEE"
            d="M265.177,47.849c-0.396,1.17-0.864,2.341-1.423,3.457v12.568h-1.603v-9.723
		c-0.486,0.72-0.972,1.404-1.494,1.98c-0.126-0.414-0.576-1.333-0.828-1.765c1.53-1.71,2.952-4.321,3.799-6.968L265.177,47.849z
		 M276.16,48.335v15.34h-1.585v-0.9h-7.418v1.063h-1.53V48.335H276.16z M274.575,61.299V49.794h-7.418v11.505H274.575z
		 M271.551,53.467v1.801h1.908v4.789h-5.042v-4.789h1.801v-1.801h-2.412v-1.242h2.412V50.28h1.333v1.944h2.502v1.242H271.551z
		 M272.162,56.474h-2.502v2.377h2.502V56.474z"
          />
          <path
            fill="#FCFAEE"
            d="M281.574,55.592c-0.721-0.522-2.232-1.369-3.313-1.927l0.9-1.242c1.044,0.486,2.575,1.26,3.331,1.8
		L281.574,55.592z M278.657,62.506c0.972-1.369,2.358-3.655,3.385-5.69l1.242,1.098c-0.936,1.873-2.143,4.033-3.187,5.708
		L278.657,62.506z M282.69,50.766c-0.757-0.576-2.251-1.44-3.367-1.999l0.937-1.225c1.098,0.504,2.61,1.314,3.402,1.837
		L282.69,50.766z M293.008,55.538c-0.145-0.324-0.324-0.684-0.559-1.098c-7.364,0.522-8.282,0.594-8.895,0.828
		c-0.09-0.324-0.36-1.116-0.559-1.584c0.396-0.09,0.757-0.486,1.242-1.117c0.486-0.63,1.999-2.971,2.972-5.257l1.729,0.504
		c-0.99,1.98-2.161,3.925-3.367,5.509l5.941-0.36c-0.63-0.937-1.368-1.909-2.053-2.701l1.423-0.72
		c1.422,1.584,2.953,3.709,3.655,5.149L293.008,55.538z M284.131,56.564h9.129v7.238h-1.692V63.1h-5.816v0.756h-1.62V56.564z
		 M285.751,58.112v3.439h5.816v-3.439H285.751z"
          />
          <path
            fill="#FCFAEE"
            d="M312.286,53.791c-0.414,0.45-0.937,0.846-1.387,1.188c0.63,0.432,1.296,0.81,1.98,1.063
		c-0.306,0.288-0.756,0.81-0.954,1.188c-0.45-0.198-0.864-0.45-1.297-0.72v3.295h-3.295v2.521c0,0.738-0.144,1.098-0.684,1.314
		c-0.559,0.216-1.333,0.234-2.467,0.234c-0.09-0.414-0.324-0.99-0.54-1.351c0.792,0.018,1.548,0.018,1.782,0
		c0.234,0,0.306-0.054,0.306-0.252v-2.467h-3.24v-3.277c-0.396,0.27-0.847,0.54-1.314,0.792c-0.198-0.342-0.595-0.811-0.937-1.044
		c-0.145,2.539-0.721,5.563-2.539,7.58c-0.252-0.324-0.864-0.918-1.17-1.098c1.278-1.458,1.818-3.313,2.053-5.114
		c-0.685,0.415-1.369,0.829-2.053,1.188l-0.522-1.495c0.702-0.288,1.675-0.81,2.719-1.332c0.019-0.486,0.019-0.918,0.019-1.369
		v-5.744h6.104c-0.108-0.432-0.271-0.864-0.396-1.26l1.675-0.342c0.216,0.486,0.433,1.099,0.594,1.603h5.96v1.422h-12.388v4.321
		c0,0.486-0.018,0.972-0.036,1.512c0.738-0.36,1.387-0.756,1.963-1.206c-0.378-0.342-0.828-0.702-1.242-0.99l0.882-0.756
		c0.396,0.27,0.883,0.612,1.278,0.955c0.379-0.378,0.685-0.738,0.973-1.135h-3.097v-1.296h3.871
		c0.252-0.469,0.432-0.937,0.558-1.405l1.566,0.216c-0.107,0.396-0.27,0.81-0.449,1.188h5.941v1.296h-3.619
		c0.342,0.45,0.72,0.864,1.152,1.261c0.45-0.396,0.954-0.847,1.242-1.188L312.286,53.791z M297.306,54.511
		c-0.198-0.882-0.667-2.413-1.063-3.547l1.242-0.468c0.433,1.098,0.918,2.575,1.116,3.421L297.306,54.511z M304.147,60.561
		c-0.774,0.99-1.891,2.179-2.737,2.917c-0.288-0.27-0.9-0.72-1.278-0.955c0.883-0.666,1.873-1.62,2.521-2.467L304.147,60.561z
		 M309.171,55.916h-5.258v0.918h5.258V55.916z M309.171,57.824h-5.258v0.918h5.258V57.824z M305.876,53.017
		c-0.396,0.648-0.864,1.278-1.423,1.854h4.268c-0.54-0.558-0.99-1.206-1.368-1.854H305.876z M309.711,60.021
		c0.864,0.828,2.07,2.017,2.665,2.737l-1.278,0.792c-0.559-0.702-1.711-1.944-2.593-2.827L309.711,60.021z"
          />
          <path
            fill="#FCFAEE"
            d="M134.142,71.717c0,0,0,0.576-0.019,0.793c-0.252,8.121-0.468,10.911-1.188,11.812
		c-0.45,0.595-0.883,0.757-1.566,0.847c-0.631,0.072-1.693,0.054-2.72,0c-0.035-0.451-0.233-1.152-0.54-1.621
		c1.152,0.09,2.197,0.107,2.647,0.107c0.359,0,0.558-0.053,0.756-0.305c0.576-0.595,0.811-3.313,1.044-10.102h-4.249
		c-0.504,1.152-1.063,2.197-1.639,3.025c-0.27-0.252-0.9-0.703-1.314-0.938v8.266h-4.879v1.367h-1.53V71.808h2.017
		c0.252-0.864,0.521-2.053,0.63-2.917l1.818,0.306c-0.306,0.901-0.648,1.854-0.937,2.611h2.881v3.403
		c1.188-1.549,2.143-3.943,2.684-6.32l1.62,0.378c-0.216,0.829-0.45,1.657-0.738,2.448H134.142z M120.476,73.266v3.422h3.349v-3.422
		H120.476z M123.824,82.125v-3.979h-3.349v3.979H123.824z M129.82,80.721c-0.504-1.1-1.675-2.863-2.629-4.16l1.314-0.738
		c0.954,1.242,2.179,2.953,2.719,4.016L129.82,80.721z"
          />
          <path
            fill="#FCFAEE"
            d="M143.157,73.555c-0.055,0.846-0.108,1.71-0.217,2.557h7.652c0,0-0.018,0.521-0.071,0.756
		c-0.343,4.969-0.685,6.949-1.405,7.688c-0.485,0.486-0.954,0.631-1.71,0.703c-0.666,0.054-1.837,0.035-3.043-0.036
		c-0.019-0.486-0.252-1.171-0.595-1.639c1.278,0.108,2.503,0.126,3.007,0.126c0.396,0,0.631-0.035,0.865-0.216
		c0.504-0.415,0.828-2.089,1.116-5.762h-6.068c-0.576,3.097-1.891,5.995-5.222,7.796c-0.252-0.449-0.773-1.025-1.224-1.368
		c4.465-2.269,4.879-6.644,5.06-10.604h-4.718v-1.639h7.706c-0.234-0.721-0.72-1.747-1.134-2.521l1.638-0.612
		c0.469,0.81,1.026,1.891,1.278,2.611l-1.206,0.522h7.4v1.639H143.157z"
          />
          <path
            fill="#FCFAEE"
            d="M157.502,77.102c-0.702-0.595-2.161-1.423-3.313-1.945l0.883-1.26
		c1.134,0.449,2.61,1.225,3.349,1.818L157.502,77.102z M154.783,84.106c0.972-1.351,2.358-3.655,3.402-5.708l1.225,1.116
		c-0.937,1.873-2.125,4.033-3.187,5.727L154.783,84.106z M156.115,69.125c1.135,0.468,2.629,1.26,3.385,1.836l-0.972,1.387
		c-0.702-0.631-2.179-1.477-3.35-1.998L156.115,69.125z M168.899,85.438c-0.145-0.486-0.396-1.063-0.738-1.692
		c-6.356,0.774-7.166,0.919-7.706,1.171c-0.091-0.361-0.379-1.207-0.576-1.676c0.378-0.09,0.72-0.504,1.152-1.17
		c0.378-0.504,1.404-2.25,2.214-4.158h-3.709v-1.586h4.447v-2.916h-3.69v-1.584h3.69v-2.899h1.711v2.899h3.835v1.584h-3.835v2.916
		h4.52v1.586h-4.97c-0.828,1.781-1.854,3.547-2.863,4.986l5.006-0.539c-0.433-0.721-0.937-1.441-1.404-2.107l1.351-0.648
		c1.242,1.566,2.557,3.656,3.078,5.078L168.899,85.438z"
          />
          <path
            fill="#FCFAEE"
            d="M176.636,72.313c-0.198,1.295-0.936,2.628-3.043,3.51c-0.197-0.342-0.63-0.846-0.972-1.134
		c1.71-0.558,2.286-1.495,2.484-2.376h-2.593v-1.314h2.665v-1.837h1.513v1.837h1.332v-1.837h1.458v1.837h1.873v-1.837h1.53v1.837
		h1.368v-1.874h1.495v1.874h2.593v1.314h-2.593v1.08c0,0.486,0.036,0.648,0.342,0.648h1.278c0.271,0,0.702-0.037,0.937-0.091
		c0.036,0.378,0.072,0.937,0.126,1.296c-0.234,0.072-0.648,0.09-1.045,0.09h-1.422c-1.423,0-1.711-0.576-1.711-1.98v-1.043h-1.368
		v2.861h-4.861v-2.861H176.636z M172.819,75.967h15.304v3.619h-1.62v-2.25h-12.136v2.25h-1.548V75.967z M186.431,82.792
		c0,0.756-0.18,1.206-0.774,1.422c-0.594,0.234-1.476,0.234-2.809,0.234c-0.072-0.414-0.306-1.045-0.521-1.44
		c0.918,0.036,1.872,0.036,2.106,0.036c0.27-0.018,0.342-0.072,0.342-0.288v-2.467h-3.619v5.149h-1.656v-5.149h-3.313v4.124h-1.62
		v-5.457h4.934V77.66h1.656v1.296h5.275V82.792z M179.48,72.313v1.584h1.873v-1.584H179.48z"
          />
          <path
            fill="#FCFAEE"
            d="M205.926,69.612v15.844h-1.801v-0.972h-11.506v0.972h-1.729V69.612H205.926z M204.125,82.917V71.322
		h-11.506v11.596H204.125z M201.893,73.789v6.608h-7.095v-6.608H201.893z M200.218,75.265h-3.835v3.673h3.835V75.265z"
          />
          <path
            fill="#FCFAEE"
            d="M215.895,77.948c-1.098,1.783-2.412,3.493-3.654,4.879l8.12-0.521
		c-0.702-1.008-1.458-2.035-2.196-2.881l1.512-0.684c1.603,1.764,3.313,4.123,4.124,5.725l-1.657,0.865
		c-0.197-0.451-0.486-0.973-0.828-1.531c-9.398,0.756-10.497,0.811-11.271,1.117c-0.09-0.361-0.359-1.207-0.576-1.656
		c0.414-0.109,0.811-0.505,1.333-1.117c0.485-0.486,1.872-2.287,2.971-4.195h-5.401v-1.674h7.147v-3.025h-5.743v-1.674h5.743v-2.666
		h1.765v2.666h5.906v1.674h-5.906v3.025h7.221v1.674H215.895z"
          />
          <path
            fill="#FCFAEE"
            d="M231.86,78.29c-0.63,0.199-1.296,0.379-1.927,0.559v4.699c0,0.811-0.144,1.26-0.594,1.494
		c-0.469,0.289-1.135,0.324-2.161,0.324c-0.054-0.396-0.233-1.115-0.45-1.529c0.576,0.018,1.152,0.018,1.333,0
		c0.198,0,0.27-0.055,0.27-0.289v-4.213l-1.908,0.54l-0.36-1.62c0.631-0.145,1.423-0.342,2.269-0.559v-3.709h-1.944v-1.549h1.944
		v-3.493h1.603v3.493h1.692v1.549h-1.692v3.259l1.711-0.468L231.86,78.29z M236.164,74.329c-0.595,3.746-2.035,6.266-3.943,7.617
		c-0.234-0.307-0.828-0.883-1.135-1.081c1.585-1.044,2.773-2.862,3.35-5.366h-2.431v-1.422h2.971l0.252-0.035L236.164,74.329z
		 M231.5,83.53h10.966v1.549H231.5V83.53z M242.411,74.473c-0.864,0.828-1.89,1.711-2.755,2.377
		c0.793,1.566,1.855,2.862,3.134,3.654c-0.36,0.289-0.847,0.865-1.099,1.297c-1.603-1.207-2.827-3.17-3.673-5.492v4.916
		c0,0.773-0.145,1.188-0.648,1.422c-0.522,0.252-1.242,0.289-2.305,0.289c-0.054-0.414-0.288-1.063-0.504-1.477
		c0.702,0.035,1.404,0.018,1.603,0.018c0.216,0,0.288-0.055,0.288-0.27v-8.445c0.828-0.396,1.746-1.025,2.484-1.639h-5.834v-1.458
		h7.4l0.324-0.091l1.063,0.811c-0.937,1.009-2.251,2.07-3.547,2.881c0.18,0.811,0.432,1.604,0.756,2.359
		c0.756-0.685,1.584-1.513,2.106-2.18L242.411,74.473z"
          />
          <path
            fill="#FCFAEE"
            d="M251.931,81.747c-0.485-0.594-1.386-1.422-2.305-2.16v3.961c0,0.865-0.216,1.297-0.756,1.531
		c-0.522,0.252-1.351,0.287-2.665,0.287c-0.054-0.396-0.288-1.063-0.486-1.458c0.829,0.019,1.657,0.019,1.891,0.019
		c0.271-0.019,0.379-0.109,0.379-0.379V80.18c-1.099,0.847-2.215,1.711-3.151,2.395l-0.792-1.332
		c1.008-0.684,2.503-1.782,3.943-2.898v-4.826h-3.691V71.97h3.691v-3.061h1.638v3.061h3.439v1.548h-3.439v3.062
		c0.631-0.757,1.278-1.62,1.711-2.305l1.44,0.595c-0.792,1.115-1.837,2.34-2.701,3.205c1.116,0.81,2.377,1.854,3.025,2.574
		L251.931,81.747z M245.899,74.527c0.738,0.919,1.548,2.143,1.854,2.952l-1.314,0.667c-0.307-0.81-1.063-2.089-1.765-3.024
		L245.899,74.527z M251.769,71.862c-0.323-0.594-1.062-1.494-1.729-2.125l1.152-0.684c0.667,0.576,1.459,1.404,1.783,2.017
		L251.769,71.862z M259.565,73.879c-0.342,2.628-0.937,4.969-1.909,6.877c0.847,1.369,1.873,2.467,3.115,3.205
		c-0.378,0.324-0.954,1.008-1.206,1.477c-1.152-0.773-2.089-1.818-2.881-3.061c-0.99,1.332-2.232,2.395-3.854,3.097
		c-0.233-0.433-0.792-1.044-1.224-1.386c1.836-0.686,3.187-1.838,4.194-3.367c-0.576-1.225-1.044-2.594-1.422-4.033
		c-0.288,0.558-0.612,1.098-0.937,1.548c-0.252-0.306-0.918-0.954-1.278-1.206c1.44-1.873,2.251-4.898,2.665-8.103l1.656,0.252
		c-0.162,1.081-0.342,2.124-0.594,3.134h4.753v1.566H259.565z M255.46,73.879c-0.054,0.197-0.108,0.414-0.18,0.594
		c0.342,1.62,0.828,3.133,1.44,4.501c0.63-1.458,1.063-3.169,1.314-5.095H255.46z"
          />
          <path
            fill="#FCFAEE"
            d="M277.907,69.719V85.51h-1.656v-0.793h-11.775v0.793h-1.585V69.719H277.907z M276.251,83.206V71.232
		h-11.775v11.974H276.251z M274.919,75.517c-0.433,1.639-1.099,3.062-1.927,4.267c0.306,0.775,0.702,1.262,1.17,1.352
		c0.216,0.072,0.378-0.666,0.486-1.783c0.271,0.27,0.774,0.631,1.063,0.793c-0.252,2.053-1.009,2.754-2.053,2.34
		c-0.666-0.18-1.206-0.701-1.639-1.494c-0.63,0.684-1.351,1.297-2.143,1.801c-0.18-0.252-0.666-0.793-0.937-1.026
		c0.486-0.288,0.954-0.612,1.387-0.972c-1.765,0.287-3.583,0.629-5.023,0.881l-0.18-1.26c1.313-0.18,3.276-0.486,5.221-0.793
		l0.036,1.117c0.396-0.342,0.757-0.721,1.081-1.135c-0.433-1.368-0.702-3.115-0.883-5.023h-5.275v-1.242h5.167
		c-0.035-0.576-0.071-1.152-0.107-1.729h1.387c0.018,0.576,0.054,1.17,0.09,1.729h2.538c-0.359-0.414-1.134-0.918-1.782-1.242
		l0.774-0.774c0.648,0.306,1.44,0.792,1.837,1.188l-0.793,0.828h1.099v1.242h-3.565c0.126,1.297,0.307,2.521,0.522,3.529
		c0.486-0.864,0.847-1.818,1.116-2.863L274.919,75.517z M269.841,75.536v3.457h-3.979v-3.457H269.841z M268.671,76.489h-1.692v1.549
		h1.692V76.489z"
          />
          <path
            fill="#FCFAEE"
            d="M290.722,79.245c0.883,2.592,2.305,4.375,3.638,4.357c0.485,0,0.684-0.757,0.773-2.594
		c0.379,0.342,1.009,0.666,1.459,0.811c-0.252,2.773-0.9,3.439-2.305,3.439c-2.359,0-4.357-2.503-5.384-6.014h-5.06v3.996
		l4.285-0.972c0,0.468,0.09,1.206,0.181,1.585c-5.042,1.242-5.798,1.422-6.284,1.711c-0.126-0.451-0.486-1.172-0.774-1.514
		c0.378-0.197,0.847-0.648,0.847-1.404V69.809h12.855v5.438h-5.006c0.055,0.828,0.181,1.676,0.343,2.432h5.96v1.566H290.722z
		 M283.844,71.358v2.341h9.417v-2.341H283.844z M288.543,77.678c-0.162-0.775-0.27-1.604-0.324-2.432h-4.375v2.432H288.543z"
          />
          <path
            fill="#FCFAEE"
            d="M301.953,74.401c1.566,0,2.809,1.26,2.809,2.809s-1.242,2.809-2.809,2.809
		c-1.549,0-2.809-1.26-2.809-2.809S300.404,74.401,301.953,74.401z M301.953,78.938c0.954,0,1.729-0.773,1.729-1.729
		c0-0.954-0.774-1.729-1.729-1.729c-0.937,0-1.729,0.774-1.729,1.729C300.225,78.165,301.017,78.938,301.953,78.938z"
          />
        </g>
      </svg>
    );
  }
}

export default ButtonHText;



// WEBPACK FOOTER //
// ./src/storyE/components/ButtonHText.tsx